import Hero from "./components/Hero";
import RadarSection from "./components/RadarSection";
import GuaSection from "./components/GuaSection";
import GuideSection from "./components/GuideSection";
import TrustSection from "./components/TrustSection";
import { siteConfig } from "@/mocks/site";

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": `${siteConfig.siteUrl}/#webpage`,
          url: `${siteConfig.siteUrl}/`,
          name: "吃瓜日报 | 吃瓜群众视角看热点，吃瓜指南瓜单雷达",
          isPartOf: { "@id": `${siteConfig.siteUrl}/#website` },
          about: "吃瓜群众热点雷达、吃瓜指南与瓜单",
          inLanguage: "zh-CN",
        })}
      </script>
      <Hero />
      <RadarSection />
      <GuaSection />
      <GuideSection />
      <TrustSection />
    </>
  );
}